var BASWebServices;
(function (BASWebServices) {
    var WebServiceData = (function () {
        function WebServiceData($rootScope, ngDialog, cmdiOptions) {
            this.$rootScope = $rootScope;
            this.ngDialog = ngDialog;
            this.cmdiOptions = cmdiOptions;
            this.data = {};
            this.invalidData = [];
            this.necessaryKeys = new Array();
            this.data["sets"] = new Array();
        }
        WebServiceData.Factory = function ($rootScope, ngDialog, cmdiOptions) {
            return new WebServiceData($rootScope, ngDialog, cmdiOptions);
        };
        WebServiceData.prototype.clear = function () {
            for (var key in this.data)
                delete this.data[key];
            for (var i = 0; i < this.necessaryKeys.length; i++)
                delete this.necessaryKeys[i];
            this.data["sets"] = new Array();
            this.invalidData = [];
        };
        WebServiceData.prototype.clearSets = function () {
            this.data["sets"] = new Array();
        };
        WebServiceData.prototype.broadcastItem = function () {
            this.$rootScope.$broadcast('mycooltestbroadcast');
        };
        WebServiceData.prototype.add = function (setNumber, key, value) {
            if (this.data["sets"][setNumber] === undefined || this.data["sets"][setNumber] == null) {
                var temp = {};
                this.data["sets"][setNumber] = temp;
            }
            this.data["sets"][setNumber][key] = value;
        };
        WebServiceData.prototype.deleteParameter = function (setNumber, key) {
            if (this.data["sets"][setNumber] === undefined)
                return;
            else
                this.data["sets"][setNumber][key] = null;
        };
        WebServiceData.prototype.deleteOption = function (key) {
            if (this.data[key] === undefined) {
            }
            else {
                this.data[key] = null;
            }
        };
        WebServiceData.prototype.addOption = function (key, value) {
            this.data[key] = value;
        };
        WebServiceData.prototype.markOptionInvalid = function (key) {
            if (!this.invalidData.includes(key)) {
                this.invalidData.push(key);
            }
        };
        WebServiceData.prototype.markOptionValid = function (key) {
            if (this.invalidData.includes(key)) {
                this.invalidData.splice(this.invalidData.indexOf(key), 1);
            }
        };
        WebServiceData.prototype.addNecessaryKeys = function (keys) {
            for (var i = 0; i < keys.length; i++) {
                var keyFound = false;
                for (var j = 0; j < this.necessaryKeys.length; j++) {
                    if (this.necessaryKeys[j] == keys[i]) {
                        keyFound = true;
                    }
                }
                if (!keyFound) {
                    this.necessaryKeys.push(keys[i]);
                }
            }
        };
        WebServiceData.prototype.doNecessaryKeysExist = function (serviceName) {
            if (this.getMissingNecessaryKeys(serviceName) == null) {
                return true;
            }
            else {
                return false;
            }
        };
        WebServiceData.prototype.doInvalidDataExist = function () {
            if (this.invalidData.length === 0) {
                return false;
            }
            else {
                return true;
            }
        };
        WebServiceData.prototype.getMissingNecessaryKeys = function (serviceName) {
            var missingKeys = new Array();
            for (var entry in this.necessaryKeys) {
                var necessaryKey = this.necessaryKeys[entry];
                if (this.data[necessaryKey] === undefined || this.data[necessaryKey] == null) {
                    var keyFound = false;
                    for (var setNumber in this.data["sets"]) {
                        if (this.data["sets"][setNumber][necessaryKey] !== undefined
                            && this.data["sets"][setNumber][necessaryKey] != null) {
                            keyFound = true;
                            break;
                        }
                    }
                    if (!keyFound)
                        missingKeys.push(necessaryKey);
                }
            }
            if (missingKeys.length == 0) {
                return null;
            }
            else {
                return missingKeys;
            }
        };
        WebServiceData.prototype.getData = function () {
            return this.data;
        };
        WebServiceData.prototype.isEmpty = function () {
            var retVal = true;
            if (this.data["sets"].length > 0) {
                retVal = false;
            }
            return retVal;
        };
        WebServiceData.prototype.setServiceName = function (webServiceName) {
            this.webServicename = webServiceName;
        };
        WebServiceData.prototype.getServiceName = function () {
            return this.webServicename;
        };
        WebServiceData.prototype.getXWWWURLEncodedStringFromOptions = function () {
            var url = BASWebServices.ConfigService.GET_BASE_URL_SERVER() + "services/" + this.webServicename + "WebLink";
            var queries = new Array();
            var allVars = "";
            for (var setNumber in this.data["sets"]) {
                var currentSet = this.data["sets"][setNumber];
                var currentQuery = url + "?";
                for (var subKey in currentSet) {
                    if (subKey != "result")
                        currentQuery += subKey + "=" + currentSet[subKey] + "&";
                }
                for (var key in this.data) {
                    if (key != "sets" && this.data[key] != null) {
                        var valueToSet = this.data[key];
                        if (typeof (valueToSet) == "string") {
                            valueToSet = BASWebServices.Helper.replaceAll(valueToSet, "\\+", "%2B");
                        }
                        else {
                            ;
                        }
                        if (valueToSet == "") {
                            ;
                        }
                        else {
                            currentQuery += key + "=" + valueToSet + "&";
                        }
                    }
                }
                currentQuery = currentQuery.slice(0, currentQuery.length - 1);
                queries.push(currentQuery);
                console.debug("Total Queries: " + queries.length + " | Current Query: " + currentQuery);
            }
            return queries;
        };
        return WebServiceData;
    }());
    BASWebServices.WebServiceData = WebServiceData;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=WebServiceData.js.map